import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientOne from "../component/client/ClientOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";

const ClientPortfolio = () => {
  return (
    <>
      <SEO title="Client Portfolio" />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne
          subtitle="Discover how we’ve made a positive impact on businesses worldwide."
          title="Trusted by Industry Leaders"
          page="Client Portfolio"
        />

        <ClientOne
          colSize="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6"
          columnGap="row-15"
        />
        <CounterUpTwo />
        <AboutThree />

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default ClientPortfolio;
